<template>
   <div class="ipinfo">
      <section class="banner_area">
         <div class="banner_inner d-flex align-items-center">
            <div class="overlay bg-parallax" data-stellar-ratio="0.9" data-stellar-vertical-offset="0" data-background=""></div>
            <div class="container">
               <div class="banner_content text-left">
                  <div class="page_link">
                     <router-link to="/"><a>Home</a></router-link>
                     <router-link to="/ipinfo"><a>Your Info</a></router-link>
                  </div>
                  <h2 style="color: black;">Your Info</h2>
               </div>
            </div>
         </div>
      </section>
      <section class="details">
         <div class="container" data-aos="fade-up">
            <table>
               <thead>
                  <tr>
                     <th scope='col'>Name</th>
                     <th scope='col'>Your Info</th>
                  </tr>
               </thead>
               <tbody>
                  <tr>
                     <td>Country</td>
                     <td class='freq'>{{country}}</td>
                  </tr>
                  <tr>
                     <td>IP Address</td>
                     <td class='freq'>{{ip}}</td>
                  </tr>
                  <tr>
                     <td>Country code</td>
                     <td class='freq'>{{country_code}}</td>
                  </tr>
                  <tr>
                     <td>Service Provider</td>
                     <td class='freq'>{{provider}}</td>
                  </tr>
                  <tr>
                     <td>Provider Region</td>
                     <td class='freq'>{{region}}</td>
                  </tr>
                  <tr>
                     <td>Provider city</td>
                     <td class='freq'>{{city}}</td>
                  </tr>
                  <tr>
                     <td>Latitude</td>
                     <td class='freq'>{{latitude}}</td>
                  </tr>
                  <tr>
                     <td>longitude</td>
                     <td class='freq'>{{longitude}}</td>
                  </tr>
               </tbody>
               <tfoot>
                  <tr>
                     <td>Time Zone</td>
                     <td>{{time_zone}}</td>
                  </tr>
               </tfoot>
            </table>
         </div>
      </section>
      <Footer/>
   </div>
</template>
<script>

   import Footer from "@/components/Footer.vue";
   import axios from 'axios';
   
   export default {
     name: "Home",
     components: {
       Footer
     },
     data() {
         return {
            country:  "",
            ip: "",
            country_code: "",
            provider: "",
            region: "",
            time_zone: "",
            latitude : "",
            longitude : "",
            city : ""
         };
      },
     mounted() {
         axios({
            method: 'get',
            url: 'https://api.2ip.ua/geo.json',
         })
         .then(response => {
            this.country = response.data.country;   
            this.ip = response.data.ip; 
            this.country_code = response.data.country_code; 
            this.region = response.data.region; 
            this.time_zone = response.data.time_zone; 
            this.latitude = response.data.latitude; 
            this.longitude = response.data.longitude; 
            this.city = response.data.city; 
         })
         .catch(() => console.log('error occured'))  

         axios({
            method: 'get',
            url: 'https://api.2ip.ua/provider.json',
         })
         .then(response => {
            this.provider = response.data.name_ripe;   
            
         })
         .catch(() => console.log('error occured'))  
      }
   };
</script>
<style scoped>
   table{
   border-collapse: collapse;
   border-spacing: 0;
   margin-right: auto;
   margin-left: auto;
   }
   th{
   padding: 10px 15px;
   text-transform: capitalize;
   }
   td{
   padding: 10px 15px;
   }
   thead{
   background: #669999;
   color: rgb(209,224,224);
   }
   tbody tr:nth-child(even){
   background: rgba(102,153,153,0.2);
   }
   tfoot tr:first-child td{
   /*background: rgba(102,153,153,0.2);*/
   border-bottom: 3px solid #669999;
   }
</style>